module.exports = __webpack_public_path__ + "static/media/group_6@3x.ac31c0ee.png";